import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { Observable, map } from 'rxjs';
import { GraphNode, GraphEdge, ProcessedGraphData } from '../models/chat.models';

@Injectable({
  providedIn: 'root'
})
export class GraphDataService {
  constructor(private apiService: ApiService) {}

  public getGraphData(statementId: string): Observable<ProcessedGraphData> {
    return this.apiService.getGraphData(statementId).pipe(
      map(response => this.processGraphResponse(response))
    );
  }

  public getChunkGraphData(chunkId: string): Observable<ProcessedGraphData> {
    return this.apiService.getChunkGraphData(chunkId).pipe(
      map(response => this.processGraphResponse(response))
    );
  }

  public getAllGraphData(statementIds: string[], chunkIds: string[] = []): Observable<ProcessedGraphData> {
    return this.apiService.getAllGraphData(statementIds, chunkIds).pipe(
      map(response => this.processGraphResponse(response))
    );
  }

  private processGraphResponse(response: any): ProcessedGraphData {
    if (!response || !response.nodes) {
      return { nodes: [], edges: [] };
    }

    const nodes = response.nodes.map((n: GraphNode) => ({
      ...n,
      id: n.id,
      dimension: this.calculateNodeDimension(n),
      properties: { ...n.properties, originalId: n.id }
    }));

    const edges = (response.edges || []).map((e: GraphEdge) => ({
      ...e,
      id: e.id,
      source: e.source,
      target: e.target
    }));

    return { nodes, edges };
  }

  private calculateNodeDimension(node: GraphNode): { width: number, height: number } {
    const labelType = (node.label || '').replace(/__/g, '');
    const props = node.properties || {};
    let contentLen = 0;

    if (labelType === 'Source') {
      const path = props['file_path'] || props['s3_key'] || 'No path';
      contentLen = path.length > 30 ? 30 : path.length;
    } else {
      const val = (props['value'] || '').toString();
      contentLen = val.length > 30 ? 35 : val.length; 
    }

    const totalLen = Math.min(45, labelType.length + 2 + contentLen);

    const charWidth = 6.5;
    const padding = 16;
    const minWidth = 70;
    const maxWidth = 280;
    const width = Math.min(maxWidth, Math.max(minWidth, totalLen * charWidth + padding));
    return { width, height: 40 };
  }

  private sanitizeId(id: string): string {
    if (!id) return id;
    return id.replace(/[^a-zA-Z0-9-_]/g, '_');
  }
}
